import { motion, useReducedMotion } from "framer-motion";

/**
 * Reveal — a consistent scroll-into-view entrance used across sections so the
 * whole page shares one motion grammar (Emil: ease-out, transform+opacity,
 * <=300ms feel, reduced-motion aware). Fires once.
 *
 * Props: delay, y (travel), x, once, className, as ("div" default).
 */
export const Reveal = ({
    children,
    delay = 0,
    y = 22,
    x = 0,
    once = true,
    className = "",
    ...rest
}) => {
    const reduce = useReducedMotion();
    const hidden = reduce ? { opacity: 0 } : { opacity: 0, y, x };
    const shown = reduce ? { opacity: 1 } : { opacity: 1, y: 0, x: 0 };

    return (
        <motion.div
            className={className}
            initial={hidden}
            whileInView={shown}
            viewport={{ once, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

export default Reveal;
